import type { Component, Entity2D } from '../../odie';

import { CountBlockOptionDef, LockBlockProps } from '../defs/block';
import { LockBlockView } from '../views/blocks/LockBlockView';

// types
//-----------------------------------------------------------------------------
export type LockBlockComponentOptions = {
  props: LockBlockProps;
  option?: number;
};

/*
    lock block component
*/
export class LockBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockLock';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: LockBlockView;

  // properties
  //-------------------------------------------------------------------------
  private props!: LockBlockProps;
  // count
  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    // update view
    this.view.count = value;
  }

  // impl
  //-------------------------------------------------------------------------
  public init(options: LockBlockComponentOptions): void {
    this.props = options.props;

    // get option def
    const optionDef = options.props.options?.[
      options.option || 0
    ] as CountBlockOptionDef; // create lock block view

    this.view = new LockBlockView(options.props);

    // set initial count
    this.count = optionDef.count;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }
}
